import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { TrainingDocument } from '../Interfaces/training';

interface TrainingState {
  documents: any[];
}

const initialState: TrainingState = {
  documents: [],
};

export const fetchTrainingDocuments = createAsyncThunk<TrainingDocument[], any>('training/fetchTrainingDocuments', async (api) => {
  
  const response = await api.get('/training/documents');

  return response.data;
});

export const selectTrainingDocuments = (state: any) => state.training.documents;

let lastDocuments = null;
let lastResult = null;

export const selectTrainingTags = (state: any) => {
    const currentDocuments = state.training.documents;

    // Check if the current documents are the same as the last documents
    if (lastDocuments === currentDocuments) {
        return lastResult; // Return the last result if documents haven't changed
    }

    // Documents have changed, update lastDocuments and compute new result
    lastDocuments = currentDocuments;

    const tags: any = [];
    currentDocuments?.forEach(document => {
        document?.tags?.forEach(tag => {
            if (!tags.some(t => t.id === tag.id)) {
                tags.push(tag);
            }
        });
    });

    // Update lastResult with the new tags array
    lastResult = tags;

    return tags;
};

export const trainingSlice = createSlice({
  name: 'training',
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrainingDocuments.fulfilled, (state, action) => {
        if (JSON.stringify(state.documents) !== JSON.stringify(action.payload)) {
          state.documents = action.payload;
        }
      })
  },
});

export default trainingSlice.reducer;